import { Component, Input } from '@angular/core';
import { ThemeService } from '../../service/theme.service';

@Component({
  selector: 'app-login-email-validation',
  templateUrl: './email-validation.component.html',
  styleUrls: ['../login.component.css', './email-validation.component.css'],
  standalone: false,
})
export class EmailValidationComponent {
  // Context bridge to parent login component
  @Input() ctx: any;
  @Input() loading = false;

  constructor(public theme: ThemeService) {}
}
